import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
// grid
import Container from "../components/grid/container";
import Row from "../components/grid/row";
import Column from "../components/grid/column";

// images
import yellow from "../assets/yellomini.svg";
import blue from "../assets/bluemini.svg";

import ybig from "../assets/big.svg";
import bbig from "../assets/bbig.svg";

// subheader
import date from "../assets/date.svg";
import location from "../assets/location.svg";

// components
import SocialLinks from "../components/social-links/social-links.component";
import clsx from "clsx";

// panel1 images
import iraida from "../assets/panels/iraida.png";
import michelle from "../assets/panels/michele.png";
import natalia from "../assets/panels/natalia.png";
import daniela from "../assets/panels/daniela.png";
import cristina from "../assets/panels/cristina.png";

// panel2 images
import kardo from "../assets/panels/kardo.png";

// workshop1
import vicky from "../assets/panels/vicky.png";
// ws2
import stefan from "../assets/panels/stefan.png";
import alex from "../assets/panels/alex.png";

import nicoleta from "../assets/panels/nicoleta.png";
import mariana from "../assets/panels/mariana.png";
import doina from "../assets/panels/doina.png";
// logos

import img1 from "../assets/logos/1.svg";
import img2 from "../assets/logos/2.svg";
import img3 from "../assets/logos/3.svg";
import img4 from "../assets/logos/4.svg";
import img5 from "../assets/logos/5.svg";
import img6 from "../assets/logos/6.svg";
import img7 from "../assets/logos/7.svg";
import img8 from "../assets/logos/8.svg";
import img9 from "../assets/logos/9.svg";
import img10 from "../assets/logos/10.svg";
import img11 from "../assets/logos/11.svg";
import img12 from "../assets/logos/12.svg";
import img13 from "../assets/logos/13.svg";
import img14 from "../assets/logos/14.svg";
import img15 from "../assets/logos/15.svg";
import img16 from "../assets/logos/16.svg";

// Social Media
import ogImage from "../assets/helmet/preview.jpg";

import { Helmet } from "react-helmet";

const logoData = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
];


const informations = [
  {
    img: date,
    text: "30 Noiembrie, 13:00 MD",
    link: "https://facebook.com/events/s/forum-mentorme-i-urmatorul-pas/1311517113631627/",
  },
  {
    img: location,
    text: "Glia Impact Hub",
    link: "https://maps.app.goo.gl/ZxTnQB1acxxPHD2AA",
  },
];

const agendaData = [
  {
    main: "Înregistrarea participanților / Cofee Break",
    time: "13:00 - 14:00",
  },
  {
    main: "Cuvânt de salut  ",
    time: "13:50 - 14:00",
  },
  {
    main: "Panel TBC - Oportunități de muncă pentru tinerii din Republica moldova din domeniul Creativ, IT și antreprenoriat, drepturile tinerilor.",
    time: "14:00 - 14:30",
  },
  {
    main: "Vlada Țurcan - Reintegrarea tinerilor in campul muncii din RM, dupa studii peste hotare.",
    time: "14:30 - 15:00",
  },
  {
    main: "Doru Curoșu - Employee Branding: Viitorul carierei tale începe cu tine",
    time: "15:00 - 16:00",
  },
  {
    main: "Sesiune de Speedmatching",
    time: "16:00 - 16:30",
  },
  {
    main: "TBC",
    time: "16:30 - 17:16",
  },
  {
    main: "TBC",
    time: "17:15 - 18:00",
  },
  {
    main: "Sesiune de Speedmatching 2",
    time: "17:00 - 17:30",
  },
  {
    main: "Viorel Barbănouă",
    time: "17:30 - 18:00",
  },
  {
    main: "Cuvânt de încheiere",
    time: "18:00 - 18:30",
  },
];

const panelsData = [
  {
    title: "Panel 1",
    margin: true,
    description: "Educația viitorului : Cum reinventăm școala secolului XXI?",
    images: [
      {
        img: iraida,
        isEmail: true,
        linkedIn: "dr.iraidasnigur@gmail.com",
        name: "Iraida Snigur",
        description: "Medic obstetrician-ginecolog, co-fondatoare Gyneco",
      },
      {
        img: michelle,
        linkedIn: "https://www.linkedin.com/in/michelle-iliev-945a096a/",
        name: "Michelle Iliev ",
        description: "Fondatoare EduTolk",
      },
      {
        img: natalia,
        linkedIn: "https://mecc.gov.md/ro/content/natalia-griu",
        name: "Natalia Grîu ",
        description:
          "Secretar de stat al Ministerului Educației, Culturii și Cercetării",
      },
      {
        img: daniela,
        linkedIn: "https://www.linkedin.com/in/dpetrusevschi/",
        name: "Daniela Petrușevschi",
        description: "Expertă în domeniul sustenabilității",
      },
      {
        img: cristina,
        linkedIn: " https://www.linkedin.com/in/cristina-voroneanu-0614a2162/",
        name: "Cristina Voroneanu",
        description:
          "Membră a rețelelor regionale Higher Education Reform Experts şi European Youth Democracy Network. Moderatoare",
      },
    ],
  },
  {
    title: "Panel 2",
    margin: true,
    description: " Forța de muncă a viitorului: Lecțiile pandemiei Covid-19",
    images: [
      {
        img: kardo,
        linkedIn: "https://www.linkedin.com/in/kardo-sharifi-9044981a3/",
        name: "Kardo Sharifi",
        description: "Project Manager, Dreamups",
      },
      {
        img: nicoleta,
        linkedIn: "https://www.linkedin.com/in/nicoletastogu/",
        name: "Nicoleta Stogu",
        description: "Specialist recrutare, Endava",
      },
      {
        img: mariana,
        linkedIn: " https://www.linkedin.com/in/mariana-rufa-3423275b/",
        name: "Mariana Rufa",
        description: "Director Executiv, European Business Association",
      },
      {
        img: doina,
        linkedIn: "https://www.linkedin.com/in/doinachiselita/",
        name: "Moderatoare: Doina Chiseliță",
        description:
          "Consultant în tehnologii financiare în cadrul EY. Moderatoare",
      },
    ],
  },
  {
    title: "Workshop 1",
    description: "Încadrarea tinerilor pe piața muncii de la A la Z",
    images: [
      {
        img: vicky,
        linkedIn: "https://www.linkedin.com/in/victoriaulinici/",
        name: "Vicky Ulinici",
        description: "People Engagement & Development Manager",
      },
    ],
  },
  {
    title: "Workshop 2",
    description: "Inteligența emoțională între conștientizare și reacție",
    images: [
      {
        img: stefan,
        linkedIn: "https://www.linkedin.com/in/popov-stefan-b3b6a0199",
        name: "Ștefan Popov",
        description: "Psiholog, psihoterapeut și cercetător",
      },
    ],
  },
  {
    title: "Workshop 3",
    description: "„Vinde-mi acest pix” sau Arta persuasiunii pentru fiecare",
    images: [
      {
        img: alex,
        isEmail: true,
        linkedIn: "constantinov.alexander@gmail.com ",
        name: "Alexandru Constantinov",
        description: "Alexander Constantinov – Trainer și Expert în vânzări",
      },
    ],
  },
];

const IndexPage = () => {
  return (
    <Container>
      <Helmet
          title={"MentorMe.md"}
          titleTemplate={`%s | mentorme.md`}
          meta={[
            {
              name: "description",
              content:
                "Conectăm și ajutăm gratuit tinerii să-și urmeze studiile universitare, să-și accelereze dezvoltarea profesională și să identifice noi oportunități de afaceri.",
            },
            {
              property: "og:title",
              content: "MentorMe - Primul program de mentorat din Moldova",
            },
            {
              property: "og:description",
              content:
                "Conectăm și ajutăm gratuit tinerii să-și urmeze studiile universitare, să-și accelereze dezvoltarea profesională și să identifice noi oportunități de afaceri.",
            },
            {
              property: "og:type",
              content: "website",
            },
            {
              property: `og:url`,
              content: `https://www.mentorme.md/`,
            },
            {
              property: `og:image`,
              content: ogImage,
            }
          ]}
        />
      <section>
        <img
          src={ybig}
          alt="decorative"
          className="absolute top-0 left-0 hidden md:block md:h-3/6 lg:h-4/6 xl:h-5/6"
        />
        <img
          src={bbig}
          alt="decorative"
          className="absolute top-0 right-0  hidden md:block md:w-2/12"
        />
        <img
          src={yellow}
          alt="decorative"
          className="absolute top-0 left-0 w-3/12 h-5/12 md:hidden"
        />
        <img
          src={blue}
          alt="decorative"
          className="absolute top-0 right-0 w-3/12 md:hidden"
        />
        <SocialLinks />
        <div className="py-4 sm:py-8 lg:pb-24">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            
            <div className="mt-16 flow-root sm:mt-24">
              <div className="-m-2 bg-gray-900/5 p-2 lg:-m-4 lg:p-4">
                <a href="https://www.facebook.com/events/1311517113631627">
                <img
                  alt="Event preview"
                  src={ogImage}
                  width={1920}
                  height={1080}
                  className="rounded-md"
                />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/*<h1 className="text-center font-bold text-blue-title md:mt-18 sm:mt-18 mt-18 text-h1m sm:text-h1t lg:text-h1d">
          MentorMe Forum
        </h1>
        <h2 className="text-center text-h2m sm:text-h2t md:text-h2d font-bold mt-6 text-pink">
          Următorul pas în carieră
        </h2>
        <Row className="justify-center gap-10 mt-20">
          {informations.map((data) => (
            <a href={data.link}>
              <Column className="flex items-center">
                <img
                  src={data.img}
                  alt={data.text}
                  className="h-5 w-5 sm:h-auto sm:w-auto"
                />

                <span className="ml-6 text-sm md:text-h1m">{data.text}</span>
              </Column>
            </a>
          ))}
          </Row>*/}

        <div className="px-6 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="https://forms.gle/4RXpNcz1tWVfA9wD8"
              className="rounded-md bg-black-600 px-3.5 py-2.5 text-sm md:text-h2m text-pink font-semibold hover:bg-black-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black-600"
            >
              Înregistrare
            </a>
            <a href="https://facebook.com/events/s/forum-mentorme-i-urmatorul-pas/1311517113631627/" 
              className="text-sm md:text-h2m font-semibold text-blue-title">
              mai multe detalii <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
        
        <div className="mt-24 md:mt-32">
          <h2 className="text-center text-h2m sm:text-h2t md:text-h3 font-bold mt-6 text-pink">
            Agenda
          </h2>
          <div className="mt-6 mb-6 md:mt-14 rounded-lg">
            {agendaData.map((data, index) => (
              <Row
                className={clsx(
                  index + 1 !== agendaData.length && "mb-6",
                  "w-full mx-auto "
                )}
              >
                <Column className="bg-blue-title py-5 pl-8 mx-auto w-10/12 rounded-xl">
                  <strong className="text-white text-span">{data.time} </strong>
                  <span className="text-white font-thin text-span">
                    {data.main}
                  </span>
                </Column>
              </Row>
            ))}
          </div>
        </div>
      </section>
    </Container>
  );
};

export default IndexPage;
